import {
  FilterId,
  FilterOptionsType,
  MultiSelectListFilter,
} from 'uplisting-frontend/utils/filters/abstract';
import { OCCASION_STATES } from 'uplisting-frontend/utils/protection-status';

export class ProtectionStatusFilter extends MultiSelectListFilter {
  id = FilterId.protectionStatus;
  optionsType = FilterOptionsType.list;
  optionsList = OCCASION_STATES;
}
